import { SvgIconType } from './svg.interface';

const LocationIcon: SvgIconType = ({
  width = 12,
  height = 12,
  className = ''
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.99999 12C5.18802 11.2819 4.4354 10.4946 3.74999 9.64646C2.72143 8.37271 1.5 6.47574 1.5 4.6681C1.49955 3.74492 1.76326 2.84235 2.25773 2.07462C2.7522 1.30689 3.45523 0.708507 4.27782 0.355202C5.10042 0.00189744 6.00561 -0.0904489 6.87885 0.0898503C7.75208 0.270149 8.5541 0.714989 9.18341 1.36807C9.60239 1.80056 9.93449 2.31491 10.1605 2.88136C10.3865 3.44781 10.5019 4.0551 10.5 4.6681C10.5 6.47574 9.27855 8.37271 8.24998 9.64646C7.56457 10.4946 6.81195 11.2819 5.99999 12ZM5.99999 2.66849C5.4885 2.66849 4.99796 2.87916 4.63629 3.25416C4.27461 3.62916 4.07142 4.13777 4.07142 4.6681C4.07142 5.19843 4.27461 5.70704 4.63629 6.08203C4.99796 6.45703 5.4885 6.66771 5.99999 6.66771C6.51148 6.66771 7.00202 6.45703 7.36369 6.08203C7.72537 5.70704 7.92856 5.19843 7.92856 4.6681C7.92856 4.13777 7.72537 3.62916 7.36369 3.25416C7.00202 2.87916 6.51148 2.66849 5.99999 2.66849Z"
      fill="#3AA5DC"
    />
  </svg>
);

export default LocationIcon;
